
import GwPageContainer from '~/patterns/molecules/page-container/page-container.vue';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
export default {
    components: {
        GwPageContainer,
        GwPageTitle,
        GwPageIntro,
    },
    props: {
        question: {
            type: String,
            default: ''
        },
        answer: {
            type: String,
            default: ''
        }
    }
};
